document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pp__tab-container').forEach((tabContainer, containerIdx) => {
    const tabs = Array.from(tabContainer.querySelectorAll('.pp__tab'));
    const panels = Array.from(tabContainer.querySelectorAll('.pp__tabpanel'));
    if (tabs.length === 0 || panels.length === 0) return;

    // ensure initial ARIA/roles and IDs
    tabs.forEach((tab, idx) => {
      tab.setAttribute('role', 'tab');
      tab.id = tab.id || `pp-tab-${containerIdx}-${idx}`;
      tab.setAttribute('tabindex', idx === 0 ? '0' : '-1');
      tab.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');

      const panel = panels[idx];
      if (panel) {
        panel.classList.toggle('pp__tabpanel--active', idx === 0);
      }
    });

    function activateTab(activeIndex) {
      tabs.forEach((t, i) => {
        t.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        t.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
        if (panels[i]) panels[i].classList.toggle('pp__tabpanel--active', i === activeIndex);
      });
    }

    tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => {
        activateTab(idx);
        tab.focus();
      });

      tab.addEventListener('keydown', (e) => {
        const key = e.key;
        let nextIndex = null;

        if (key === 'ArrowRight') nextIndex = (idx + 1) % tabs.length;
        if (key === 'ArrowLeft') nextIndex = (idx - 1 + tabs.length) % tabs.length;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== null) {
          e.preventDefault();
          tabs[nextIndex].focus();
          activateTab(nextIndex);
        }
      });
    });
  });
});
